module.exports = __webpack_public_path__ + "static/media/logo-startup-plus.458d23f9.png";